import type { Address, Shipper, Consignee, Product, Store, Order } from '@/types'

// モックアドレスデータ
export const mockAddresses: Address[] = [
  {
    AddressId: 1,
    Name: '東京商事株式会社',
    Furigana: 'トウキョウショウジカブシキガイシャ',
    PostalCD: '1000001',
    PrefectureName: '東京都',
    CityName: '千代田区',
    Address1: '丸の内1-1-1',
    Phone: '03-1234-5678',
    Fax: '03-1234-5679',
    MailAddress: 'info@tokyo-shoji.co.jp',
    Memo: '月末締め翌月払い',
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
    IsActive: true,
  },
  {
    AddressId: 2,
    Name: '山田太郎',
    Furigana: 'ヤマダタロウ',
    PostalCD: '5410041',
    PrefectureName: '大阪府',
    CityName: '大阪市中央区',
    Address1: '北浜1-2-3',
    Address2: 'パークマンション101',
    Phone: '06-9876-5432',
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
    IsActive: true,
  },
  {
    AddressId: 3,
    Name: '大阪工業株式会社',
    Furigana: 'オオサカコウギョウカブシキガイシャ',
    PostalCD: '5500002',
    PrefectureName: '大阪府',
    CityName: '大阪市西区',
    Address1: '江戸堀2-3-4',
    Phone: '06-1111-2222',
    Fax: '06-1111-2223',
    MailAddress: 'contact@osaka-kogyo.co.jp',
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
    IsActive: true,
  },
  {
    AddressId: 4,
    Name: '鈴木花子',
    Furigana: 'スズキハナコ',
    PostalCD: '2200002',
    PrefectureName: '神奈川県',
    CityName: '横浜市西区',
    Address1: 'みなとみらい3-4-5',
    Phone: '045-333-4444',
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
    IsActive: true,
  },
  {
    AddressId: 5,
    Name: '名古屋商会',
    Furigana: 'ナゴヤショウカイ',
    PostalCD: '4600002',
    PrefectureName: '愛知県',
    CityName: '名古屋市中区',
    Address1: '栄5-6-7',
    Phone: '052-555-6666',
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
    IsActive: true,
  },
]

// モック荷主データ
export const mockShippers: Shipper[] = [
  {
    ShipperId: 1,
    AddressId: 1,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
    Address: mockAddresses[0],
  },
  {
    ShipperId: 2,
    AddressId: 3,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
    Address: mockAddresses[2],
  },
  {
    ShipperId: 3,
    AddressId: 5,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
    Address: mockAddresses[4],
  },
]

// モック送付先データ
export const mockConsignees: Consignee[] = [
  {
    ConsigneeId: 1,
    AddressId: 2,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
    Address: mockAddresses[1],
  },
  {
    ConsigneeId: 2,
    AddressId: 4,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
    Address: mockAddresses[3],
  },
  {
    ConsigneeId: 3,
    AddressId: 3,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
    Address: mockAddresses[2],
  },
]

// モック商品データ
export const mockProducts: Product[] = [
  {
    ProductId: 1,
    ProductName: '桃 5kg',
    UnitPrice: 3500,
    IsDefault: true,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
  },
  {
    ProductId: 2,
    ProductName: '桃 10kg',
    UnitPrice: 6800,
    IsDefault: false,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
  },
  {
    ProductId: 3,
    ProductName: 'フジ 5kg',
    UnitPrice: 2800,
    IsDefault: false,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
  },
  {
    ProductId: 4,
    ProductName: 'フジ 10kg',
    UnitPrice: 5400,
    IsDefault: false,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
  },
]

// モック集配所データ
export const mockStores: Store[] = [
  {
    StoreId: 1,
    StoreName: 'ヤマト運輸 東京主管支店',
    IsDefault: true,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
  },
  {
    StoreId: 2,
    StoreName: 'ヤマト運輸 大阪主管支店',
    IsDefault: false,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
  },
  {
    StoreId: 3,
    StoreName: 'ヤマト運輸 名古屋主管支店',
    IsDefault: false,
    IsActive: true,
    CreatedAt: '2024-01-01T00:00:00Z',
    UpdatedAt: '2024-01-01T00:00:00Z',
  },
]

// モック注文データ
export const mockOrders: Order[] = [
  {
    OrderId: 1,
    OrderDate: '2024-01-15',
    ShipperId: 1,
    StoreId: 1,
    OrderTotal: 7700,
    ItemCount: 2,
    PaymentStatus: 'paid',
    OrderStatus: 'delivered',
    TrackingNumber: 'Y123456789012',
    CreatedAt: '2024-01-15T10:00:00Z',
    UpdatedAt: '2024-01-16T14:30:00Z',
    ShipperName: '東京商事株式会社',
    StoreName: 'ヤマト運輸 東京主管支店',
    Shipper: mockShippers[0],
    Store: mockStores[0],
    OrderDetails: [
      {
        OrderDetailId: 101,
        OrderId: 1,
        ConsigneeId: 1,
        ProductId: 1,
        Quantity: 2,
        UnitPrice: 3500,
        LineTotal: 7700,
        CreatedAt: '2024-01-15T10:00:00Z',
        UpdatedAt: '2024-01-15T10:00:00Z',
        ConsigneeName: '山田太郎',
        ProductName: '桃 5kg',
        Consignee: mockConsignees[0],
        Product: mockProducts[0],
      },
    ],
  },
  {
    OrderId: 2,
    OrderDate: '2024-01-16',
    ShipperId: 1,
    StoreId: 1,
    OrderTotal: 7480,
    ItemCount: 1,
    PaymentStatus: 'authorized',
    OrderStatus: 'ordered',
    TrackingNumber: 'Y123456789013',
    CreatedAt: '2024-01-16T11:30:00Z',
    UpdatedAt: '2024-01-16T11:30:00Z',
    ShipperName: '東京商事株式会社',
    StoreName: 'ヤマト運輸 東京主管支店',
    Shipper: mockShippers[0],
    Store: mockStores[0],
    OrderDetails: [
      {
        OrderDetailId: 102,
        OrderId: 2,
        ConsigneeId: 2,
        ProductId: 2,
        Quantity: 1,
        UnitPrice: 6800,
        LineTotal: 7480,
        CreatedAt: '2024-01-16T11:30:00Z',
        UpdatedAt: '2024-01-16T11:30:00Z',
        ConsigneeName: '鈴木花子',
        ProductName: '桃 10kg',
        Consignee: mockConsignees[1],
        Product: mockProducts[1],
      },
    ],
  },
  {
    OrderId: 3,
    OrderDate: '2024-01-17',
    ShipperId: 2,
    StoreId: 2,
    OrderTotal: 17820,
    ItemCount: 3,
    PaymentStatus: 'authorized',
    OrderStatus: 'ordered',
    CreatedAt: '2024-01-17T09:15:00Z',
    UpdatedAt: '2024-01-17T09:15:00Z',
    ShipperName: '大阪工業株式会社',
    StoreName: 'ヤマト運輸 大阪主管支店',
    Shipper: mockShippers[1],
    Store: mockStores[1],
    OrderDetails: [
      {
        OrderDetailId: 103,
        OrderId: 3,
        ConsigneeId: 3,
        ProductId: 4,
        Quantity: 3,
        UnitPrice: 5400,
        LineTotal: 17820,
        CreatedAt: '2024-01-17T09:15:00Z',
        UpdatedAt: '2024-01-17T09:15:00Z',
        ConsigneeName: '大阪工業株式会社',
        ProductName: 'フジ 10kg',
        Consignee: mockConsignees[2],
        Product: mockProducts[3],
      },
    ],
  },
]

// ダッシュボード用の統計データ
export const mockDashboardStats = {
  totalOrders: mockOrders.length,
  todayOrders: mockOrders.filter(o => o.OrderDate === '2024-01-19').length,
  totalShippers: mockShippers.length,
  totalConsignees: mockConsignees.length,
  completedOrders: mockOrders.length, // 更新後は状態管理なしで全部完了として扱う
  pendingOrders: 0,
  processingOrders: 0,
  cancelledOrders: 0,
  totalRevenue: mockOrders.reduce((sum, o) => sum + (o.OrderTotal || 0), 0),
}